module.exports = __webpack_public_path__ + "img/starwars2.c29feeed.jpg";